module.exports = function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/ramda/src/internal/_isObject.js
 ** module id = 114
 ** module chunks = 0
 **/